import WorkOrders from './WorkOrders';

export default WorkOrders;
